module.exports = __webpack_public_path__ + "static/media/sitemap.6bd8f480.xml";